module.exports = __webpack_public_path__ + "img/ico_order_successful@3x.03f7d19c.png";